import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center w-full space-y-8" }
const _hoisted_2 = { class: "flex flex-row w-3/5 space-x-8 3xl:w-2/5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/2 text-gray-400" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-secondary" }, "Information : "),
  /*#__PURE__*/_createTextVNode(" Une agence est considérée comme une succursale lié à votre activité de transport publique. A cet effet, elle sera dirigée/managée sous la compétence d'un personnel judicieusement choisi. Ce dernier obtiendra des privilèges administratif dédiés : Manager. "),
  /*#__PURE__*/_createElementVNode("span", { class: "underline cursor-pointer text-secondary" }, " En savoir plus sur le contenu des rôles.")
], -1)
const _hoisted_4 = { class: "flex flex-col w-3/5 space-y-8 3xl:w-2/5" }
const _hoisted_5 = { class: "flex flex-col space-y-5" }
const _hoisted_6 = {
  class: "grid grid-cols-2 gap-2 overflow-y-auto custumScroll",
  stylee: "height: calc(100vh - 20rem)"
}
const _hoisted_7 = { class: "flex flex-col col-span-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Nom de l'agence "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Ville "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Nom de la Rue "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_13 = { class: "flex flex-col" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Adresse de messagerie "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" })
], -1)
const _hoisted_15 = { class: "flex flex-col" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Contact "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1)
const _hoisted_17 = { class: "flex flex-col col-span-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Description "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (facultatif)")
], -1)
const _hoisted_19 = { class: "flex flex-col w-full" }

import api from "@/api";
	import { ref, watch, onMounted, watchEffect, provide, inject } from "vue";
	import rules from "@/rules";
	import { currentStation, refreshStationsUser, userInfos } from "@/state/api/userState";
	import { validate, validateAll } from "@/validator";
	import useNotyf from "@/composable/useNotyf";
	import PrerequisitesService from "@/services/global/prerequisitesService";
	import { generateQueryParams } from "@/utils";
	import { not } from "@vueuse/core";

	/**
	 * Variables
	 */
	
export default /*#__PURE__*/_defineComponent({
  __name: 'NewAgency',
  setup(__props) {

	const notify = useNotyf();
	const activeView = ref(inject("activeView"));
	const stations: any = ref(inject("stations"));
	const getAllStations: any = inject("getAllStations");
	const isLoading = ref(false);
	const isUploading = ref(false);
	const refreshStationData = ref(inject("refreshStationData"));
	const selectedRow = ref({});
	const illustrationIMG = ref(null);
	const stationData = ref({
		city: 1,
		station_name: "",
		station_address: "",
		station_phone: "",
		station_email: "",
		zip_code: "",
		postal_box: "",
		description: "",
		banner_url: null,
	});

	watchEffect(() => {
		//
	});

	watch(stationData.value, () => {
		// validateAll(validations.value);
		if(stationData.value.city != null )
			validate(validations.value.city);
		if(stationData.value.station_name != "" )
			validate(validations.value.station_name);
		if(stationData.value.station_email != "" )
			validate(validations.value.station_email);
		if(stationData.value.station_address != "" )
			validate(validations.value.station_address);
		if(stationData.value.station_phone != "" )
			validate(validations.value.station_phone);

	});

	const citiesList = ref([
		{ value: "Yaoundé", key: "1" },
		{ value: "Douala", key: "2" },
	]);

	// Validation rules
	const validations = ref<any>({
		city: {
			value: stationData,
			validator: (value: any) => rules.global.number.test(value.city),
			msg: {
				error: "La ville de l'entreprise est requise",
			},
		},
		station_name: {
			value: stationData,
			validator: (value: any) => rules.station.name.test(value.station_name),
			msg: {
				error: "Le nom de l'entreprise doit contenir au moins 3 caractères",
			},
		},
		station_email: {
			value: stationData,
			validator: (value: any) => rules.global.email.test(value.station_email),
			msg: {
				error: "L'e-mail de l'entreprise doit être valide",
			},
		},
		station_address: {
			value: stationData,
			validator: (value: any) => rules.global.address.test(value.station_address),
			msg: {
				error: "L'adresse de l'entreprise doit contenir au moins 5 caractères",
			},
		},
		station_phone: {
			value: stationData,
			validator: (value: any) => rules.global.phone.test(value.station_phone),
			msg: {
				error: "Le téléphone de l'entreprise doit être valide",
			},
		},
	});

	/**
	 * Functions
	 */
	const handleNewStation = async (filter?: any, page?: any) => {
		isLoading.value = true;
		await api()
			.stations.create(stationData.value)
			.then(async (res: any) => {
				isLoading.value = false;
				refreshStationData.value = true;
				activeView.value = "list";
				await getAllStations();
				await refreshStationsUser();
				await PrerequisitesService.run();
			})
			.catch((err: any) => {
				console.log(err);
				isLoading.value = false;
			});
	};

	const getAllCities = async () => {
		await api()
			.others.cities.getAll(`?country=${userInfos.value?.organisation?.country_id}`)
			.then((res: any) => {
				console.log('res.data.cities: ', res.data.cities);
				citiesList.value = res.data.cities.map((t: any) => {
					return { key: t.id, value: t.label };
				});
				isLoading.value = false;
			})
			.catch((err: any) => {
				console.log(err);
				isLoading.value = false;
			});
	};

	const newStation = async (filter?: any, page?: any) => {
		if (validateAll(validations.value)) {
			handleNewStation();
		} else {
			notify.warning("Veuillez remplir tous les champs.");
		}
	};

	const  uploadFile = async (file:any) => {

		const formData = new FormData();
		formData.append("file", file);

		isUploading.value = true;
		const params = {
			station: currentStation.value?.uuid,
			visibility: "public",
			category: "banners"
		};

		try {
			const resp = await api().files.upload(generateQueryParams(params), formData);
			console.log('resp444: ', resp);
			if (resp?.response.code == 200) {
				notify.success("Bannière importée.");
				stationData.value.banner_url = resp.data.preview_url;
			} else {
				notify.error(resp?.response.message ?? 'Une erreur s\'est produite. Veuillez réessayer !');
			}
		} catch (error) {
			console.error(error);
			notify.error("Erreur lors de l'upload.");
		} finally {
			isUploading.value = false;
		}
	};

	/**
	 * Lifecycle
	 */
	onMounted(async () => {
		// await getAllManager();
		await getAllCities();
	});

return (_ctx: any,_cache: any) => {
  const _component_PreviewTag = _resolveComponent("PreviewTag")!
  const _component_InputTag = _resolveComponent("InputTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_TextAreaTag = _resolveComponent("TextAreaTag")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PreviewTag, {
        css: 'w-1/2',
        onModel: _cache[0] || (_cache[0] = (e) => uploadFile(e.file))
      }),
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(illustrationIMG.value), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_InputTag, {
              placeholder: "Ex : Jahagal Voyage",
              type: "text",
              onModel: _cache[1] || (_cache[1] = (e) => stationData.value.station_name = e),
              error: validations.value.station_name.message,
              value: stationData.value.station_name
            }, null, 8, ["error", "value"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_SelectTag, {
              placeholder: "Sélectionner la Ville",
              onModel: _cache[2] || (_cache[2] = (e) => stationData.value.city = e.key),
              error: validations.value.city.message,
              data: JSON.stringify(citiesList.value),
              selected: stationData.value.city
            }, null, 8, ["error", "data", "selected"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_InputTag, {
              type: "text",
              placeholder: "Adresse de localisation",
              onModel: _cache[3] || (_cache[3] = (e) => stationData.value.station_address = e),
              error: validations.value.station_address.message,
              value: stationData.value.station_address
            }, null, 8, ["error", "value"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_InputTag, {
              type: "email",
              placeholder: "Ex: abcd@exemple.com",
              onModel: _cache[4] || (_cache[4] = (e) => stationData.value.station_email = e),
              error: validations.value.station_email.message,
              value: stationData.value.station_email
            }, null, 8, ["error", "value"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_InputTag, {
              placeholder: "Ex : +237 655 14 92 21",
              type: "tel",
              onModel: _cache[5] || (_cache[5] = (e) => stationData.value.station_phone = e),
              error: validations.value.station_phone.message,
              value: stationData.value.station_phone
            }, null, 8, ["error", "value"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_TextAreaTag, {
              css: "mt-2",
              onModel: _cache[6] || (_cache[6] = (e) => stationData.value.description = e),
              value: stationData.value.description
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_ButtonTag, {
            label: "Créer",
            loader: isLoading.value,
            "text-loading": 'Création en cours...',
            onClick: newStation
          }, null, 8, ["loader"])
        ])
      ])
    ])
  ]))
}
}

})